// extracted by mini-css-extract-plugin
export default {"mCard":"ID-z","image":"JD-z","imageNoBackground":"KD-z","imageHasCategory":"LD-z","fullWidth":"MD-z"};